/**
 * Sanitizza una stringa in un codice conforme allo schema dei codici
 * (`^[a-zA-Z]([a-zA-Z0-9_-]*)$`): iniziale alfabetica, poi lettere, numeri,
 * `-` e `_`. Il case viene preservato.
 *
 * Passi:
 * 1. Trim
 * 2. Caratteri non consentiti → `_`
 * 3. Underscore consecutivi collassati
 * 4. Caratteri non alfabetici iniziali rimossi (l'iniziale deve essere una
 *    lettera)
 * 5. `_` e `-` finali rimossi
 *
 * Ritorna stringa vuota se non resta nulla di valido: spetta al chiamante
 * gestire un eventuale fallback.
 */
const INVALID_CHARS = /[^a-zA-Z0-9_-]/g;
const CONSECUTIVE_UNDERSCORES = /_{2,}/g;
const LETTER = /[a-zA-Z]/;

function isLetter(char: string): boolean {
  return LETTER.test(char);
}

export function sanitizeCode(value: string): string {
  const replaced = value
    .trim()
    .replace(INVALID_CHARS, '_')
    .replace(CONSECUTIVE_UNDERSCORES, '_');

  // Iterazioni lineari, nessun rischio ReDoS
  let start = 0;
  while (start < replaced.length && !isLetter(replaced[start])) start++;
  let end = replaced.length;
  while (
    end > start &&
    (replaced[end - 1] === '_' || replaced[end - 1] === '-')
  ) {
    end--;
  }

  return replaced.slice(start, end);
}
